var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{attrs:{"icon":_vm.interchangeabilityIcon,"title":_vm.interchangeabilityTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }